import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { BackgroundContainer, AbsoluteCenter } from '../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import { DiagonalLine, VerticalLine, HorizontalLine } from '../../../components/Layout/Line';
import { Panel } from '../../../components/Layout/Panel';
import { Screen, SplitScreen, SplitScreenContentHolder } from '../../../components/Layout/Screen';
import Logo from '../../../components/Logo';
import Title, { Highlight, Subtext } from '../../../components/Title';
import SealAnimation from '../../../components/SealAnimation';

// Assets
import { brandColors, device } from '../../../styles/variables';
import microscope from '../../../assets/images/microscope.png';

const StyledSplitScreen = SplitScreen.extend`
  position: relative;
  height: 100%;
  ${({ backgroundColor = 'none' }) => `
    background: ${backgroundColor};
  `};
  pointer-events: all;
`;

// const mediaQuery = `${device.laptop} and ${fixPoints.oneMax}`;
const TitlePosition = styled.div`
  width: 100%;
  max-width: 1169px;
  padding: 154px 0 0;
  @media ${device.tablet} {
    padding: 121px 0 0 0;
  }
  @media ${device.laptop} {
    padding: 106px 0 0 0;
  }

  .aboutFeatureSubText {
    font-size: 16px;
    line-height: 27px;
    max-width: 312px;
    @media ${device.tablet} {
      max-width: unset;
      font-size: 22px;
      line-height: 42px;
    }
  }
`;

const ContentHolder = styled.div`
  position: relative;
  pointer-events: none;
  padding: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
`;

const SealContainer = styled.div`
  margin-top: 95px;

  @media ${device.tablet} {
    margin: 0;
    position: absolute;
    left: 61%;
    top: 106%;
  }

  @media ${device.laptop} {
    top: 120%;
  }
`;

const FeatureScreen = () => (
  <Screen background={brandColors.lightblue}>
    <BackgroundContainer>
      <HorizontalLine />
      <VerticalLine />
      <StyledSplitScreen>
        <SplitScreenContentHolder direction="right">
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <SplitScreenContentHolder>
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <Panel top="unset" left="unset" bottom="0" right="0" />
      <AbsoluteCenter>
        <img src={microscope} alt="Microscope" />
      </AbsoluteCenter>
    </BackgroundContainer>
    <ContentHolder>
      <Logo />
      <ContentContainer>
        <TitlePosition>
          <Title subtitle="about us" color={brandColors.blue}>
            We are here to make <Highlight>learning</Highlight> an adventure
            <SealContainer>
              <SealAnimation />
            </SealContainer>
            <Subtext className="aboutFeatureSubText">
              We are Radical Departures.<br /> We create learning solutions<br /> for healthcare
              audiences.
            </Subtext>
          </Title>
        </TitlePosition>
      </ContentContainer>
    </ContentHolder>
  </Screen>
);

export default connect()(FeatureScreen);



// WEBPACK FOOTER //
// ./src/pages/About/screens/Feature.jsx